import {
  LOAD_SERVICES_CONTENT_FULFILLED,
  LOAD_SERVICES_CONTENT_REJECTED
} from "../actions/types";

const initialState = {
  loaded: false,
  pageTitle: "Loading...",
  services: [],
  error: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOAD_SERVICES_CONTENT_FULFILLED:
      return {
        ...state,
        loaded: true,
        services: action.payload.data
      };
    case LOAD_SERVICES_CONTENT_REJECTED:
      return {
        ...state,
        error: true
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/services-reducer.js